<template>
  <li class="c-steps__item relative flex gap-6">
    <article
      class="c-steps__content flex-1 relative order-1 pl-6 pb-8"
      :class="{ 'c-steps__content--completed': currentStep > stepNo }"
      :data-step-no="stepNo"
    >
      <h3 class="font-bold mb-2" v-if="title || subtitle">
        {{ title }}
        <br />
        {{ subtitle }}
      </h3>
      <slot></slot>
    </article>
  </li>
</template>
<script>
export default {
  name: 'StepperStep',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    stepNo: {
      required: true,
      type: Number
    },
    title: {
      required: true,
      type: String
    },
    subtitle: {
      required: false,
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
.c-steps__item {
  &:last-child {
    .c-steps__content {
      &:before {
        @apply hidden;
      }
    }
  }
}
.c-steps__content {
  &:before {
    @apply absolute right-full top-0 h-full;
    background-image: repeating-linear-gradient(
      to bottom,
      var(--primary-color) 0,
      var(--primary-color) 5px,
      transparent 5px,
      transparent 10px
    );
    content: "";
    width: 2px;
  }
  &:after {
    @apply absolute top-0 h-6 w-6 bg-white z-0 border-2 border-primary border-solid rounded-full font-semibold flex justify-center items-center;
    content: attr(data-step-no);
    left: -13px;
  }
  &--completed {
    &:before {
      @apply bg-primary;
    }
    &:after {
      @apply bg-primary text-white;
    }
  }
}
</style>
